import { css } from '@emotion/react'
import { HeadProps, PageProps, graphql } from 'gatsby'

import { Seo } from '@/features/common/'
import {
  BeyondTheClassroom,
  Curriculum,
  DivisionHero,
  DivisionSubnav,
} from '@/features/division-sections'
import {
  ContactSection,
  HighlightSection,
  IntroSection,
} from '@/features/page-sections'

const DivisionPage = ({
  data: { datoCmsDivisionPage: page },
}: PageProps<Queries.DivisionPageQuery>): JSX.Element => {
  const styles = {
    page: css`
      background: #fff;
    `,
  }
  return (
    <div css={styles.page}>
      <DivisionHero
        divisionName={page?.divisionName}
        heroImages={page?.heroImages}
      />
      <DivisionSubnav data={page} />
      <IntroSection
        body={page?.intro}
        quote={page?.introQuote?.[0]}
        id="overview"
      />
      <section>
        {page?.highlights?.map((highlight, i) => (
          <HighlightSection
            data={highlight}
            textAlignment={i % 2 ? 'RIGHT' : 'LEFT'}
            bgColor={i % 2 ? 'GRAY' : 'WHITE'}
            key={i}
          />
        ))}
      </section>
      <Curriculum
        curriculumYears={page?.curriculumYears}
        id="curriculum"
      />
      <BeyondTheClassroom
        heading={page?.beyondTheClassroomHeading}
        data={page?.beyondTheClassroom}
        id="beyond-the-classroom"
      />
      {page?.contact && (
        <ContactSection
          data={page.contact}
          key={page.contact.id}
          id="contact"
        />
      )}
    </div>
  )
}

export const Head = ({
  data: { datoCmsDivisionPage: page },
}: HeadProps<Queries.DivisionPageQuery>) => (
  <Seo seoMetaTags={page?.seoMetaTags} />
)

export const data = graphql`
  query DivisionPage($id: String!) {
    datoCmsDivisionPage(id: { eq: $id }) {
      ...DivisionHero
      intro {
        ...BodyTextBlock
      }
      introQuote {
        ...Quote
      }
      highlights {
        ...HighlightSection
      }
      curriculumYears {
        ...CurriculumYear
      }
      beyondTheClassroomHeading
      beyondTheClassroom {
        ...BeyondTheClassroom
      }
      contact {
        ...ContactSection
      }
      seoMetaTags {
        tags
      }
    }
  }
`

export default DivisionPage
